const tableOption = function() {
  return {
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 300,
    dialogWidth: '800px',
    emptyText: '暂无数据',
    edit: '修改罚单',
    column: [
      {
        label: '罚单类型',
        prop: 'violationType',
        slot: true,
        search: true,
        editDisplay: true,
        editDisabled: true,
        searchDefault: [],
        type: 'select',
        overHidden: true,
        formatter: (row, value) => {
          const statusMap = {
            2: '超速罚单',
            3: '车辆违规罚单'
          }
          return statusMap[value];
        },
        viewFormatter: (row, value) => {
          const statusMap = {
            2: '超速罚单',
            3: '车辆违规罚单'
          }
          return statusMap[value];
        },
        minRows: 4,
        span: 12,
        searchPlaceholder: '请选择罚单类型',
        dicData: [
          {
            label: '超速罚单',
            value: '2'
          },
          {
            label: '车辆违规罚单',
            value: '3'
          }
        ],
        rules: [
          { required: true, message: '请选择罚单类型', trigger: 'blur' }
        ],
      },
      {
        label: '违规时间',
        prop: 'violationTime',
        value: '',
        search: true,
        type: 'datetimerange',
        formslot: true,
        editDisplay: true,
        viewDisplay: false,
        searchPlaceholder: '请选择违规时间',
        rules: [
          { required: true, message: '请选择违规时间', trigger: 'blur' }
        ]
      },
      {
        label: '地点',
        prop: 'area',
        value: '',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: false,
        span: 12,
        rules: [
          { required: true, message: '请输入违规地点', trigger: 'blur' }
        ]
      },
      {
        label: '所在中队',
        prop: 'securityWorkGroupName',
        value: '',
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        span: 12,
       
      },
      {
        label: '罚单人',
        prop: 'name',
        type: 'text',
        value: '',
        formslot: true,
        addDisplay: true,
        editDisplay: true,
        overHidden: true,
        viewDisplay: true,
        maxlength: 64,
        span: 12,
        rules: [
          { required: true, message: '请选择罚单人', trigger: 'blur' }
        ]
      },
      {
        label: '罚单人类型',
        prop: 'personnelType',
        type: 'select',
        value: '',
        overHidden: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        editDisabled: true,
        formatter: (row, value) => {
          const statusMap = {
            1: '员工',
            2: '外来人员'
          }
          return statusMap[value];
        },
        viewFormatter: (row, value) => {
          const statusMap = {
            1: '员工',
            2: '外来人员'
          }
          return statusMap[value];
        },
        span: 12,
        searchPlaceholder: '请选择罚单人类型',
        dicData: [
          {
            label: '员工',
            value: '1'
          },
          {
            label: '外来人员',
            value: '2'
          }
        ],
      },
      {
        label: '罚单人手机号',
        prop: 'phone',
        type: 'text',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        addDisabled: false,
        editDisabled: true,
        viewDisabled: false,
      },
      {
        label: '违规车牌',
        prop: 'plateCode',
        addDisplay: true,
        editDisplay: true,
        overHidden: true,
        editDisabled: true,
        span: 12,
      },
      {
        label: '罚单状态',
        prop: 'status',
        search: true,
        editDisplay: true,
        searchDefault: [],
        type: 'select',
        editDisabled: false,
        formatter: (row, value) => {
          const statusMap = {
            1: '忽略',
            2: '未处理',
            3: '已处理'
          }
          return statusMap[value];
        },
        viewFormatter: (row, value) => {
          const statusMap = {
            1: '忽略',
            2: '未处理',
            3: '已处理'
          }
          return statusMap[value];
        },
        searchPlaceholder: '请选择状态',
        dicData: [
          {
            label: '忽略',
            value: '1'
          },
          {
            label: '未处理',
            value: '2'
          },
          {
            label: '已处理',
            value: '3'
          }
        ],
        span: 12,
        rules: [
          { required: true, message: '请选择状态', trigger: 'blur' }
        ],
      },
      {
        label: '处理人',
        prop: 'modifier',
        span: 24,
        addDisplay: true,
        editDisplay: false
      },
      {
        label: '处理时间',
        prop: 'modifyTime',
        span: 24,
        addDisplay: true,
        editDisplay: false
      }
    ]
  }
}
export default tableOption